import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	AddBannerMobileContainer,
	AddItemsContainer,
} from "./style";
import { BannerMobileItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useBannerMobileContext } from "../../context/BannerMobileContext/BannerMobileContext";


const AddBannerMobile = () => {
	const { addBannerMobile, operationStatus } = useBannerMobileContext();

	return (
		<AddBannerMobileContainer>
			<AddItemsContainer>
				<h3>Yeni Mobil Banner Ekleme</h3>
				<Divider />
				<Collapse
					items={BannerMobileItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={({ isActive }) => (
						<UpOutlined rotate={isActive ? 0 : -180} />
					)}
					defaultActiveKey={["1", "2", "3", "4"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={addBannerMobile} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
						Mobil Banner Ekle
					</MainButtonComponent>
				</ActionButtonComponent>
			</AddItemsContainer>
		</AddBannerMobileContainer>
	);
};

export default AddBannerMobile;
